import script from "./VuetifyDateTimePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./VuetifyDateTimePicker.vue?vue&type=script&setup=true&lang=js"

import "./VuetifyDateTimePicker.vue?vue&type=style&index=0&id=1f94ece1&lang=css"

const __exports__ = script;

export default __exports__